import { Navigate, useNavigate } from 'react-router';
import { ReactElement, useEffect } from 'react';
import { LOGIN, PASSWORD_RECOVERY_NEW_PASSWORD } from './routes';

type Props = {
  children: ReactElement;
};

export default function PrivateRoute({ children }: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('fromTemporaryPassword') === 'true') {
      navigate(PASSWORD_RECOVERY_NEW_PASSWORD, { replace: true });
    }
  }, [navigate]);

  if (sessionStorage.getItem('token')) {
    return children;
  }

  return <Navigate to={LOGIN} replace />;
}
